/* eslint-disable max-lines */
/* eslint-disable vars-on-top */
/* eslint-disable no-undefined */
/* eslint-disable no-negated-condition */
/* eslint-disable max-params */
/* eslint-disable id-length */
/* eslint-disable id-match */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
PHI.productdetail = { // NOSONAR
  activeThumb: null,

  initPageEvents: function() {
    this.initGalleryCarousel();
    this.initGalleryThumbZoom();
    this.initGalleryFullZoom();
    this.displayImageInCarousel();
  },

  hideLeftCorousel: function($leftcorousel, hidemoreStr) {
    if (!$('.ph-desk-pdpCar-zoom .ph-selectedimage').prev().hasClass('ph-resp__sliderdots')) {
      $leftcorousel.addClass(hidemoreStr);
    } else {
      $leftcorousel.removeClass(hidemoreStr);
    }
  },

  hideRightCorousel: function($rightzoomcorousel, hidemoreStr) {
    if (!$('.ph-desk-pdpCar-zoom .ph-selectedimage').next().hasClass('ph-resp__sliderdots')) {
      $rightzoomcorousel.addClass(hidemoreStr);
    } else {
      $rightzoomcorousel.removeClass(hidemoreStr);
    }
  },

  pdpDeskMobDataInd: function() {
    var carInd = '',
        index = 'index';

    if ($(window).width() > 900) {
      carInd = $('.ph-desk-pdpCar .thumb-90.active').attr('data-' + index);
    } else {
      carInd = $('.ph-mob-pdpCar .thumb.active').attr('data-' + index);
    }

    return carInd;
  },

  pdpZoomImg: function(zoomElement, zoomUrldatatype, $leftcorousel, $rightzoomcorousel, $pdpzoomimageclose, hidemoreStr) {
    var zoomEleCls = 'zoomelement',
        imageSecStr = 'imageSec';

    $('.ph-' + zoomEleCls).zoom({
      url: zoomElement,
      on: 'click',
      onZoomIn: function() {
        if (zoomUrldatatype === 'image') {
          $('.zoomImg').addClass('ph-zoom-image');
          $pdpzoomimageclose.addClass('hidden');
          $rightzoomcorousel.addClass(hidemoreStr);
          $leftcorousel.addClass(hidemoreStr);
          $('.ph-desk-pdpCar-zoom .ph-corousel__thumb').addClass('hidden');
          $('.ph-' + zoomEleCls).css('overflow', 'visible');
          $('.ph-' + zoomEleCls + ' .ph-' + imageSecStr).addClass('hidden');
        }
      },
      onZoomOut: function() {
        if (zoomUrldatatype === 'image') {
          $('.zoomImg').removeClass('ph-zoom-image');
          $pdpzoomimageclose.removeClass('hidden');
          $rightzoomcorousel.removeClass(hidemoreStr);
          $leftcorousel.removeClass(hidemoreStr);
          $('.ph-desk-pdpCar-zoom .ph-corousel__thumb').removeClass('hidden');
          $('.ph-' + zoomEleCls).css('overflow', 'hidden');
          $('.ph-' + zoomEleCls + ' .ph-' + imageSecStr).removeClass('hidden');

          if ($(window).width() > 900) {
            PHI.productdetail.hideLeftCorousel($leftcorousel, hidemoreStr);
            PHI.productdetail.hideRightCorousel($rightzoomcorousel, hidemoreStr);
          }
        }
      }
    });
  },

  pdpZoomImgCall: function(zoomElement, zoomUrldatatype, $leftcorousel, $rightzoomcorousel, $pdpzoomimageclose, hidemoreStr) {
    var zoomEleCls = 'zoomelement';

    if (zoomUrldatatype === 'image') {
      PHI.productdetail.pdpZoomImg(zoomElement, zoomUrldatatype, $leftcorousel, $rightzoomcorousel, $pdpzoomimageclose, hidemoreStr);
    } else if (zoomUrldatatype === 'video' || zoomUrldatatype === 'threesixty') {
      $('#ph-chfullscn .zoomImg').remove();
      $('.ph-' + zoomEleCls).trigger('zoom.destroy');
    }
  },

  videoThreesixtyCarCallLeft: function(galposAttr) {
    var galpos = '',
        selectedimage = 'selectedimage';

    if ($('.ph-' + selectedimage).prevAll(':has(.ph-product__rotateIcon):first').length > 0) {
      PHI.productdetail.displayThreesixtyImgInCarousel();
    } else {
      galpos = $('.ph-' + selectedimage).prev().find('.ph-product__playIcon').attr(galposAttr);

      PHI.productdetail.displayVideoInCarousel(galpos);
    }
  },

  videoThreesixtyCarCallRight: function(galposAttr) {
    var galpos = '',
        edimage = 'edimage';

    if ($('.ph-select' + edimage).nextAll(':has(.ph-product__rotateIcon):first').length > 0) {
      PHI.productdetail.displayThreesixtyImgInCarousel();
    } else {
      galpos = $('.ph-select' + edimage).next().find('.ph-product__playIcon').attr(galposAttr);
      PHI.productdetail.displayVideoInCarousel(galpos);
    }
  },

  zoomCloseActiveCall: function(carIndZoom) {
    if ($(window).width() > 900) {
      $('.thumb-90.ph-pdpcar-' + carIndZoom).addClass('active');
    } else {
      $('.thumb.ph-pdpcarmob-' + carIndZoom).addClass('active');
    }
  },

  initialZoomDestroy: function() {
    var elStr = 'element';

    $('#ph-chfullscn .zoomImg').remove();
    $('.ph-zoom' + elStr).trigger('zoom.destroy');
  },


  initGalleryCarousel: function() {
    $('.thumbs-container .thumbs').jcarousel();

    $('.arrowleft')
      .on('jcarouselcontrol:active', function() {
        $(this).removeClass('inactive');
      })
      .on('jcarouselcontrol:inactive', function() {
        $(this).addClass('inactive');
      })
      .jcarouselControl({
        target: '-=1'
      });

    $('.arrowright')
      .on('jcarouselcontrol:active', function() {
        $(this).removeClass('inactive');
      })
      .on('jcarouselcontrol:inactive', function() {
        $(this).addClass('inactive');
      })
      .jcarouselControl({
        target: '+=1'
      });
  },

  displayImageInCarousel: function(curElement) {
    var videoSec = '.ph-videoSec',
        imageSec = '.ph-imageSec',
        threesixtySec = '.cloudimage-inner-box',
        zooma = $('.ph-pdpzoom-a').val(),
        zoomb = $('.ph-pdpzoom-b').val(),
        zoomc = $('.ph-pdpzoom-c').val(),
        newElement = '',
        dwnldLink = 'download-link';

    if (curElement === undefined) {
      newElement = $('#ph-prodimagepdp').val();
    } else {
      newElement = curElement;
    }

    var updatenewElementa = newElement + zooma,
        updatenewElementb = newElement + zoomb,
        updatenewElementc = newElement + zoomc;

    $('#productImagePrimary .ph-pdpzoomimages__normal').attr('src', updatenewElementa);
    $('#productImagePrimary .ph-pdpzoomimages').attr('src', updatenewElementb);
    $('#productImagePrimary .ph-pdpzoominimages').attr('src', updatenewElementc);
    $(videoSec).addClass('hidden');
    $(threesixtySec).addClass('hidden');
    $(imageSec).removeClass('hidden');
    $('.ph-' + dwnldLink).removeClass('hidden');
    $('.ph-pdp-vdoHide').css('display', 'block');
  },
  displayVideoInCarousel: function(curElement) {
    var videoSec = 'videoSec',
        imageSec = 'imageSec',
        threesixtySec = '-inner-box',
        dwnldLink = 'download-link',
        vdoHideStr = 'pdp-vdoHide';

    $('.ph-' + imageSec).addClass('hidden');
    $('.cloudimage' + threesixtySec).addClass('hidden');
    $('.video_' + curElement).removeClass('hidden');
    $('.ph-' + videoSec).removeClass('hidden');
    $('.ph-' + dwnldLink).addClass('hidden');
    $('.ph-' + vdoHideStr).css('display', 'none');
  },
  displayThreesixtyImgInCarousel: function() {
    var videoSec = '.ph-videoSec',
        imageSec = '.ph-imageSec',
        threesixtySec = '.cloudimage-inner-box';

    $(imageSec).addClass('hidden');
    $(videoSec).addClass('hidden');
    $(threesixtySec).removeClass('hidden');
    $('.ph-download-link').addClass('hidden');
    $('.ph-pdp-vdoHide').css('display', 'block');
  },
  initGalleryThumbZoom: function() {
    $('.ph-product__playIcon,.ph-product__rotateIcon,#productImageGallery img').on('click', function() {
      var thumb = '',
          galAttr = 'data-galleryposition',
          primaryimagesrcAttr = 'primaryimagesrc';

      $('.ph-video').addClass('hidden');

      $('.ph-desk-pdpCar .thumb-90').removeClass('active');
      $('.ph-mob-pdpCar img').parent().parent().siblings('.thumb').removeClass('active');

      if ($(this).attr('data-type') === 'video') {
        PHI.productdetail.displayVideoInCarousel($(this).attr(galAttr));
      }

      if ($(this).attr('data-type') === 'threesixty') {
        PHI.productdetail.displayThreesixtyImgInCarousel();
      }

      if ($(this).attr('data-type') === 'image') {
        PHI.productdetail.displayImageInCarousel($(this).attr('data-' + primaryimagesrcAttr));
      }

      if (ACC.productDetail.activeThumb) {
        ACC.productDetail.activeThumb.removeClass('active');
      }

      $('#zoomLink, #imageLink').attr('href', $('#zoomLink').attr('data-href') + '?galleryPosition=' + $(this).attr(galAttr));

      thumb = $(this).closest('.thumb');

      thumb.addClass('active');
      ACC.productDetail.activeThumb = thumb;
    });
  },

  initGalleryFullZoom: function() {
    $('#imageLink').on('click', function(event) {
      event.preventDefault();
      $.colorbox({
        href: $(this).attr('href'),
        height: 555,
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();

          $('#colorbox .productImageGallery .jcarousel-skin').jcarousel({
            vertical: true
          });
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });
  }
};

$.extend(true, ACC.productDetail, PHI.productdetail);

$('.ph-rightzoomimage__carousal').click(function() {
  var primaryimagesrcAttr = 'primaryimagesrc';

  if ($(this).attr('data-type') === 'image') {
    PHI.productdetail.displayImageInCarousel($(this).attr('data-' + primaryimagesrcAttr));
  }
});

$(document).ready(function() {
  function exitHandler() {
    var switchscn = '.ph-switchscreen',
        exitfullscn = 'ph-icon-exit-fullscreen',
        fullscn = 'ph-icon-fullscreen';

    if (document.webkitIsFullScreen === false || document.mozFullScreen === false || document.msFullscreenElement === false) {
      $(switchscn).removeClass(exitfullscn).addClass(fullscn);
    }
  }

  if (document.addEventListener) {
    document.addEventListener('fullscreenchange', exitHandler, false);
    document.addEventListener('mozfullscreenchange', exitHandler, false);
    document.addEventListener('MSFullscreenChange', exitHandler, false);
    document.addEventListener('webkitfullscreenchange', exitHandler, false);
  }
});

$(document).ready(function() {
  var $featurebuttonless = $('.ph-productdetailpage__featurebuttonless');
  var $featurebuttonall = $('.ph-productdetailpage__featurebuttonall');

  $(document).on('click', '.ph-productfeature_button_showall', function() {
    $('.ph-productfeature_section_showmore').removeClass('ph-d-none');
    $(this).addClass('ph-d-none');
    $('.ph-productfeature_button_showless').removeClass('ph-d-none');
  });

  $(document).on('click', '.ph-productfeature_button_showless', function() {
    $('.ph-productfeature_section_showmore').addClass('ph-d-none');
    $(this).addClass('ph-d-none');
    $('.ph-productfeature_button_showall').removeClass('ph-d-none');
  });

  function showAllSpecifications() {
    $(document).on('click', '.ph-productdetailpage__featurebuttonall', function(event) {
      $('.ph-productdetailpage__featuretoggle').removeClass('ph-d-none');
      $featurebuttonless.removeClass('ph-d-none');
      $featurebuttonall.addClass('ph-d-none');
      window.scrollTo(0, event.pageY - 200);
    });
    $(document).on('click', '.ph-productdetailpage__featurebuttonless', function() {
      $('.ph-productdetailpage__featuretoggle').addClass('ph-d-none');
      $featurebuttonless.addClass('ph-d-none');
      $featurebuttonall.removeClass('ph-d-none');
      window.scrollTo(0, $('.ph-productdetailpage__featurespecification').offset().top);
    });
  }

  if ($('.page-productDetails').length > 0) {
    showAllSpecifications();
    window.CI360.init();
  }
});

$(document).ready(function() {
  var $pdpzoomimages = $('.ph-pdpzoomimages'),
      $pdpzoomimagesnormal = $('.ph-pdpzoomimages__normal'),
      $pdpzoomimageclose = $('.ph-pdp__zoomimageclose'),
      rightZoomCarousel = 'rightzoomimage__carousal',
      $rightzoomcorousel = $('.ph-' + rightZoomCarousel),
      $respfullscreen = $('.ph-respfullscreen'),
      $leftcorousel = $('.ph-leftzoomimage__carousal'),
      galposAttr = 'data-galleryposition',
      selImgString = 'ph-selectedimage',
      $sliderdots = $('.ph-resp__sliderdots'),
      largeWidth = '&$jpglarge$&wid=1250',
      dataInd = 'data-index',
      hidemoreStr = 'ph-hidemore',
      sliderdotspdpcarStr = '.ph-resp__sliderdots.ph-pdpcar-',
      primaryimagesrcAttr = 'primaryimagesrc';

  if ($('.ph-productfeature_image').length > 0) {
    $('.ph-productfeature_rowimage').addClass('ph-pdpfeatures__minheight');
  }

  $('.ph-download-link').click(function() {
    var imageResolution = document.getElementById('ph-image-download-params').value,
        fileUrl = $('.ph-pdpzoomimages__normal').attr('src'),
        updatedURL = fileUrl,
        name = $('#ph-img-title').val(),
        userEventObj = '',
        desc = 'PDP image download',
        trigger = 'linkCategory.clickPDPImgDownload',
        compname = 'ph-download-link';

    if (fileUrl.includes('?ppl=true')) {
      var url = fileUrl.split('?ppl=true');

      updatedURL = url[0].concat('?ppl=true' + imageResolution);
    }

    var xhr = new XMLHttpRequest();

    xhr.responseType = 'blob';
    xhr.onload = function() {
      var a = document.createElement('a');

      a.href = window.URL.createObjectURL(xhr.response);
      a.download = name + '.jpeg';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.remove();
    };
    xhr.open('GET', updatedURL);
    xhr.send();
    userEventObj = ACC.googleanalytics.createUserEventForGa(fileUrl, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  PHI.productdetail.hideLeftCorousel($leftcorousel, hidemoreStr);

  $('.ph-icon-fullscreen.ph-pdp-vdoHide, .ph-pdpzoomimages__normal').click(function() {
    var carInd = '',
        prodDetStr = 'productDetails';

    PHI.productdetail.initialZoomDestroy();

    carInd = PHI.productdetail.pdpDeskMobDataInd();

    $('.page-' + prodDetStr).addClass('ph-pdpImg-overflow');
    $('.ph-imageSec, .ph-videoSec').addClass('ph-pdpImg-p');
    $('#ph-chfullscn').addClass('ph-fullscn-check');
    $respfullscreen.removeClass('hidden');
    $pdpzoomimagesnormal.addClass('hidden');
    $pdpzoomimages.removeClass('hidden');
    $pdpzoomimageclose.removeClass('hidden');
    $('.ph-zoomdots').removeClass('hidden');
    $(sliderdotspdpcarStr + carInd).addClass(selImgString);

    PHI.productdetail.hideLeftCorousel($leftcorousel, hidemoreStr);
    PHI.productdetail.hideRightCorousel($rightzoomcorousel, hidemoreStr);

    var zoomUrl = $(sliderdotspdpcarStr + carInd + ' img').attr('data-' + primaryimagesrcAttr),
        zoomElement = zoomUrl + largeWidth,
        zoomUrldatatype = $(sliderdotspdpcarStr + carInd + ' img').attr('data-type');

    PHI.productdetail.pdpZoomImgCall(zoomElement, zoomUrldatatype, $leftcorousel, $rightzoomcorousel, $pdpzoomimageclose, hidemoreStr);
  });

  $('.ph-' + rightZoomCarousel).click(function() {
    var carIndZoom = $('.ph-desk-pdpCar-zoom .ph-resp__sliderdots.ph-selectedimage').next().attr(dataInd),
        zoomUrl = $(sliderdotspdpcarStr + carIndZoom + ' img').attr('data-' + primaryimagesrcAttr),
        zoomElement = zoomUrl + largeWidth,
        zoomUrldatatype = $(sliderdotspdpcarStr + carIndZoom + ' img').attr('data-type');

    PHI.productdetail.initialZoomDestroy();
    $('.ph-video').addClass('hidden');

    PHI.productdetail.videoThreesixtyCarCallRight(galposAttr);

    $('.ph-selectedimage').next().find('.ph-resp__pdpimage').trigger('click');
    PHI.productdetail.hideLeftCorousel($leftcorousel, hidemoreStr);
    PHI.productdetail.hideRightCorousel($rightzoomcorousel, hidemoreStr);

    PHI.productdetail.pdpZoomImgCall(zoomElement, zoomUrldatatype, $leftcorousel, $rightzoomcorousel, $pdpzoomimageclose, hidemoreStr);
  });

  $('.ph-leftzoomimage__carousal').click(function() {
    var carIndZoom = $('.ph-desk-pdpCar-zoom .ph-resp__sliderdots.ph-selectedimage').prev().attr(dataInd),
        zoomUrl = $(sliderdotspdpcarStr + carIndZoom + ' img').attr('data-' + primaryimagesrcAttr),
        zoomElement = zoomUrl + largeWidth,
        zoomUrldatatype = $(sliderdotspdpcarStr + carIndZoom + ' img').attr('data-type');

    PHI.productdetail.initialZoomDestroy();
    $('.ph-video').addClass('hidden');

    PHI.productdetail.videoThreesixtyCarCallLeft(galposAttr);

    $('.ph-selectedimage').prev().find('.ph-resp__pdpimage').trigger('click');
    PHI.productdetail.hideLeftCorousel($leftcorousel, hidemoreStr);
    PHI.productdetail.hideRightCorousel($rightzoomcorousel, hidemoreStr);

    PHI.productdetail.pdpZoomImgCall(zoomElement, zoomUrldatatype, $leftcorousel, $rightzoomcorousel, $pdpzoomimageclose, hidemoreStr);
  });

  $('.ph-desk-zoom-car').click(function() {
    var carIndZoom = $(this).attr(dataInd),
        zoomUrl = $(sliderdotspdpcarStr + carIndZoom + ' img').attr('data-' + primaryimagesrcAttr),
        zoomElement = zoomUrl + largeWidth,
        zoomUrldatatype = $(sliderdotspdpcarStr + carIndZoom + ' img').attr('data-type');

    PHI.productdetail.initialZoomDestroy();
    PHI.productdetail.pdpZoomImgCall(zoomElement, zoomUrldatatype, $leftcorousel, $rightzoomcorousel, $pdpzoomimageclose, hidemoreStr);

    if ($(window).width() > 900) {
      var carIndlength = $('.ph-desk-pdpCar-zoom .ph-resp__sliderdots').length,
          carIndlengthStr = carIndlength.toString();

      if (carIndZoom === '1') {
        $leftcorousel.addClass(hidemoreStr);
        $rightzoomcorousel.removeClass(hidemoreStr);
      } else if (carIndZoom === carIndlengthStr) {
        $rightzoomcorousel.addClass(hidemoreStr);
        $leftcorousel.removeClass(hidemoreStr);
      } else {
        $leftcorousel.removeClass(hidemoreStr);
        $rightzoomcorousel.removeClass(hidemoreStr);
      }
    }
  });

  $('.ph-pdp__zoomimageclose').click(function() {
    var sliderdotsselectedimage = 'sliderdots.ph-selectedimage',
        carIndZoom = $('.ph-desk-pdpCar-zoom .ph-resp__' + sliderdotsselectedimage).attr(dataInd),
        prodDetStr = 'productDetails';

    $('.page-' + prodDetStr).removeClass('ph-pdpImg-overflow');
    $respfullscreen.addClass('hidden');
    $('.ph-zoomdots').addClass('hidden');
    $pdpzoomimagesnormal.removeClass('hidden');
    $pdpzoomimages.addClass('hidden');
    $sliderdots.removeClass(selImgString);
    $('.ph-imageSec, .ph-videoSec').removeClass('ph-pdpImg-p');

    PHI.productdetail.zoomCloseActiveCall(carIndZoom);
  });


  $sliderdots.click(function() {
    $(this).addClass(selImgString).siblings().removeClass(selImgString);
  });
});

$(document).ready(function() {
  var normal = '__normal',
      $respfullscreen = $('.ph-respfullscreen');

  $(document).on('keydown', function(event) {
    if (event.keyCode === 27) {
      $respfullscreen.addClass('hidden');
      $('.ph-pdpzoomimages' + normal).removeClass('hidden');
      $('.ph-imageplayer__image').addClass('hidden');
      $('.ph-imageplayer__extrazoomimage').addClass('hidden');
      $('.ph-resp__sliderdots').removeClass('ph-selectedimage');
    }
  });

  if ($('.thumb-90').length < 2) {
    $('.arrowright').addClass('ph-hide__corousel__en');
    $('.arrowleft').addClass('ph-hide__corousel__en');
  }
});

$(document).ready(function() {
  if ($('.ph-pdp_description_rightsection').length > 0) {
    var productCode = $('#ph-prod-code').val();

    ACC.common.checkForBlockedProducts(productCode);
  }
});

$(document).ready(function() {
  var atpgraphview = '#ph-availb-graph',
      pdpAddcartBtn = 'pdp_addtocart_button',
      disabledBtn = 'ph-disable-button',
      notifyBtn = '.ph-pdpnotifybut',
      notifySection = '.ph-notify-sec';

  $(document).on('mouseenter', '.ph-promotionicon__blue', function() {
    $(this).siblings('.ph-price__msg').removeClass('hidden');
  });

  $(document).on('mouseleave', '.ph-promotionicon__blue', function() {
    $(this).siblings('.ph-price__msg').addClass('hidden');
  });

  $(document).on('mouseenter', '.ph-promotionicon__red', function() {
    $(this).siblings('.ph-promotion__msg').removeClass('hidden');
  });

  $(document).on('mouseleave', '.ph-promotionicon__red', function() {
    $(this).siblings('.ph-promotion__msg').addClass('hidden');
  });
  $(document).on('click', '.ph-productdetailpage__resourcesbox', function() {
    var url = $(this).closest('a').attr('href'),
        desc = 'PDPresources - ' + $(this).find('.ph-productdetailpage__addinfofilesize').text(),
        trigger = 'linkCategory.clickPDPresources',
        compname = 'ph-productdetailpage__resourcesbox',
        userEventObj = '';

    userEventObj = ACC.googleanalytics.createUserEventForGa(url, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  if (location.hash.includes(atpgraphview)) {
    setTimeout(function() {
      $(window).scrollTop($(atpgraphview).offset().top - 100);
    }, 100);
  }

  $(document).on('click', '.ph-scrollto-atpgraph', function() {
    $(window).scrollTop($(atpgraphview).offset().top - 100);
  });
  $(document).on('click', '.ph-scrollto-featurespec', function() {
    $(window).scrollTop($('.ph-productdetailpage__resources').offset().top - 100);
  });

  if ($('.ph-sap-orderBlock').length > 0) {
    $('.ph-' + pdpAddcartBtn).addClass(disabledBtn);
    $(notifyBtn).addClass(disabledBtn);
    $(notifySection).css('pointer-events', 'none');
    $('.ph-mini-cart-menu').addClass('hidden');
  } else {
    $('.ph-mini-cart-menu').removeClass('hidden');
  }

  if ($('#ph-mainvalidProduct').val() === 'false') {
    $('.ph-' + pdpAddcartBtn).addClass(disabledBtn);
  }
});

$(document).ready(function() {
  if ($('.page-productDetails').length > 0) {
    $('#ph-chfullscn').addClass('hidden');
  }
});
/* eslint-enable max-lines */
/* eslint-enable vars-on-top */
/* eslint-enable no-undefined */
/* eslint-enable no-negated-condition */
/* eslint-enable max-params */
/* eslint-enable id-length */
/* eslint-enable id-match */
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
